
import styles from "../AddMarkerModal/AddIncidentModal.module.css";
import {Button, FormControl, IconButton, InputLabel, ListItemText, MenuItem, Select, TextField} from "@mui/material";
import {useFetchAllTypeContainerPlatforms} from "../../../../hooks/guide/useFetchAllTypeContainerPlatforms";
import React, {useEffect, useReducer, useState} from "react";
import {useFetchAllCounterparty} from "../../../../hooks/guide/useFetchAllCounterparty";
import useAppSnackbar from "../../../../hooks/useAppSnackbar";
import {containerPlatformService} from "../../../../services/guide/containerPlatform-service";
import {CreateContainerPlatform} from "../../../../types/api/guide/containerPlatform.types";
import {mapCoordinateToGeoPoint} from "../../../../utils/mapCoordinate";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import {useFetchAllTypeContainer} from "../../../../hooks/guide/useFetchAllTypeContainer";
import ScheduleBuilder, {ScheduleBuildResult} from "../../../../components/ScheduleBuilder/ScheduleBuilder";
import {CreateSchedule} from "../../../../types/api/planRoute/shedule.types";
import {scheduleService} from "../../../../services/planRoute/schedule-service";
import {useFetchAllSchedules} from "../../../../hooks/planRoute/useFetchAllSchedules";

type ContainerInCPForm = {
    uiId: string; // локальный идентификатор для React key
    volume: number | "";
    kind: string;
    typeContainerId: string;
};

interface CreateContainerPlatformsState {
    title: string;
    typeContainerPlatformsId: string;
    address: string;
    counterpartyId: string;
    containers: ContainerInCPForm[];
    schedule?: ScheduleBuildResult;
    scheduleName?: string;
    scheduleId?: string;
}

type Action =
    | { type: "SET_FIELD"; name: keyof Omit<CreateContainerPlatformsState, "containers">; value: any }
    | { type: "SET_CONTAINER_FIELD"; uiId: string; name: keyof Omit<ContainerInCPForm, "uiId">; value: any }
    | { type: "ADD_CONTAINER" }
    | { type: "REMOVE_CONTAINER"; uiId: string }
    | { type: "SET_FORM"; payload: CreateContainerPlatformsState }
    | { type: "SET_SCHEDULE"; value: ScheduleBuildResult };

const createContainerPlatformReducer = (state: CreateContainerPlatformsState, action: Action): CreateContainerPlatformsState => {
    switch (action.type) {
        case "SET_FIELD":
            return { ...state, [action.name]: action.value };

        case "SET_CONTAINER_FIELD":
            return {
                ...state,
                containers: state.containers.map((c) =>
                    c.uiId === action.uiId ? { ...c, [action.name]: action.value } : c
                ),
            };
        case "SET_SCHEDULE":
            return { ...state, schedule: action.value };
        case "ADD_CONTAINER":
            return {
                ...state,
                containers: [
                    ...state.containers,
                    {
                        uiId: createUiId(),
                        volume: "",
                        kind: "",
                        typeContainerId: "",
                    },
                ],
            };

        case "REMOVE_CONTAINER":
            return {
                ...state,
                containers: state.containers.filter((c) => c.uiId !== action.uiId),
            };

        case "SET_FORM":
            return action.payload;

        default:
            return state;
    }
}

const createUiId = () => Math.random().toString(16).slice(2) + Date.now().toString(16);

interface AddContainerPlatformsModalProps {
    coords: [number, number];
    onClose: () => void;
    refetchData: () => void;
}

export default function AddContainerPlatformsModal({
    coords,
    onClose,
    refetchData
}: AddContainerPlatformsModalProps) {
    const {showSuccess, showWarning, showError, SnackbarComponent} = useAppSnackbar();
    const {data: typesCP} = useFetchAllTypeContainerPlatforms();
    const {data: counterparties} = useFetchAllCounterparty();
    const { data: typeContainers = [] } = useFetchAllTypeContainer();
    const {data: schedules = []} = useFetchAllSchedules()

    const [createdId, setId] = useState<string>("");

    const initializeData: CreateContainerPlatformsState = {
        address: "",
        counterpartyId: "",
        title: "",
        typeContainerPlatformsId: "",
        containers: [],
    }

    const [state, dispatch] = useReducer(createContainerPlatformReducer, initializeData);
    const handleValue = (event) => {
        dispatch({
            type: "SET_FIELD",
            name: event.target.name,
            value: event.target.value
        })
    };

    const handleContainerValue =
        (uiId: string) =>
            (event: any) => {
                const { name, value } = event.target;

                if (name === "typeContainerId") {
                    const selectedType = typeContainers.find((t) => t.id === value);
                    const nextVolume =
                        selectedType !== undefined ? selectedType.volume : "";
                    dispatch({ type: "SET_CONTAINER_FIELD", uiId, name: "typeContainerId", value });
                    dispatch({ type: "SET_CONTAINER_FIELD", uiId, name: "volume", value: nextVolume });
                    return;
                }

                dispatch({ type: "SET_CONTAINER_FIELD", uiId, name, value });
            };

    const handleSaveCp = async () => {
        for (const c of state.containers) {
            if (!c.typeContainerId) {
                showWarning("Для каждого контейнера выберите тип");
                return;
            }
            const vol = Number(c.volume);
            if (c.volume === "" || !Number.isFinite(vol)) {
                showWarning("Для каждого контейнера должен быть задан объём (подставляется из типа)");
                return;
            }
        }
        try {
            const cp: CreateContainerPlatform = {
                address: state.address,
                counterpartyId: state.counterpartyId,
                title: state.title,
                typeContainerPlatformsId: state.typeContainerPlatformsId,
                location: mapCoordinateToGeoPoint(coords),
                containerInCp: state.containers.map((c) => ({
                    volume: Number(c.volume),
                    kind: c.kind.trim(),
                    typeContainerId: c.typeContainerId,
                })),
            }
            const newId = await containerPlatformService.create(cp);
            setId(newId.data);
            showSuccess("Сохрание КП прошло успешно");
            refetchData?.()
            // onClose();
        }catch (e){
            showError(e?.response?.data);
        }
    };

    const handleSaveSchedule = async () => {
        if (!state.schedule){
            showWarning("Введите график");
            return;
        }
        const createSchedule: CreateSchedule = {
            cpId: createdId,
        }
        if (state.scheduleId){
            console.log(state.scheduleId);
            createSchedule.scheduleId = state.scheduleId;
        }else{
            createSchedule.name = state.scheduleName;
            createSchedule.scheduleParts = state.schedule.parts.map(part => ({
                dtStart: part.dtStart,
                rrule: part.rrule,
                uiConfig: JSON.stringify(part.uiConfig), // ScheduleUiConfig -> string
            }))
        }
        console.log(createSchedule);
        try {
            await scheduleService.create(createSchedule)
            showSuccess("График успешно сохранен")
            onClose();
        }catch (e) {
            showError("Ошибка при сохранении графика")
        }
    }

    useEffect(() => {
        console.log(state)
    }, [state])

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modal}>
                <div className={styles.modalHeader}>
                    <h3 className={styles.modalTitle}>Добавить контейнерную площадку</h3>
                    <button className={styles.modalClose} onClick={onClose}>
                        ×
                    </button>
                </div>

                <div className={styles.modalBody}>
                    {createdId === "" && (
                        <>
                            <div className={styles.modalField}>
                                <div className={styles.modalLabel}>Координаты</div>
                                <div className={styles.modalCoords}>
                                    {coords[0].toFixed(6)}, {coords[1].toFixed(6)}
                                </div>
                            </div>

                            <div className={styles.modalField}>
                                <div className={styles.modalLabel}>Адрес</div>
                                <div className={styles.modalCoords}>
                                    <TextField name={"address"} type={"text"} onChange={handleValue}/>
                                </div>
                            </div>

                            <div className={styles.modalField}>
                                <div className={styles.modalLabel}>Название</div>
                                <div className={styles.modalCoords}>
                                    <TextField required={true} name={"title"} type={"text"} onChange={handleValue}/>
                                </div>
                            </div>

                            <div className={styles.modalField}>
                                <div className={styles.modalLabel}>Тип КП</div>
                                <div className={styles.modalCoords}>
                                    <Select
                                        name={"typeContainerPlatformsId"}
                                        value={state?.typeContainerPlatformsId}
                                        onChange={handleValue}
                                        renderValue={(selected) =>
                                            typesCP?.find((type) => type.id === selected)?.name ?? ""
                                        }
                                        MenuProps={{
                                            disablePortal: true,
                                            PaperProps: { sx: { zIndex: 20000 } },
                                        }}
                                    >
                                        {typesCP.map((type) => (
                                            <MenuItem key={type?.id} value={type?.id}>
                                                <ListItemText primary={type?.name} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </div>
                            </div>

                            <div className={styles.modalField}>
                                <div className={styles.modalLabel}>Контрагент</div>
                                <div className={styles.modalCoords}>
                                    <Select
                                        name={"counterpartyId"}
                                        value={state?.counterpartyId}
                                        onChange={handleValue}
                                        renderValue={(selected) =>
                                            counterparties?.find((type) => type.id === selected)?.name ?? ""
                                        }
                                        MenuProps={{
                                            disablePortal: true,
                                            PaperProps: { sx: { zIndex: 20000 } },
                                        }}
                                    >
                                        {counterparties.map((counterparty) => (
                                            <MenuItem key={counterparty?.id} value={counterparty?.id}>
                                                <ListItemText primary={counterparty?.name} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </div>
                            </div>

                            {/* Контейнеры */}
                            <div className={styles.modalField}>
                                <div className={styles.modalLabel} style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <span>Контейнеры</span>

                                    <Button
                                        variant="outlined"
                                        startIcon={<AddIcon />}
                                        onClick={() => dispatch({ type: "ADD_CONTAINER" })}
                                    >
                                        Добавить
                                    </Button>
                                </div>

                                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                                    {state.containers.length === 0 && (
                                        <div style={{ opacity: 0.7 }}>Контейнеров пока нет</div>
                                    )}

                                    {state.containers.map((c) => (
                                        <div
                                            key={c.uiId}
                                            style={{
                                                border: "1px solid rgba(0,0,0,0.12)",
                                                borderRadius: 8,
                                                padding: 12,
                                                display: "grid",
                                                gridTemplateColumns: "1fr 1fr 1fr auto",
                                                gap: 12,
                                                alignItems: "center",
                                            }}
                                        >
                                            <TextField
                                                name="kind"
                                                label="Вид"
                                                value={c.kind}
                                                onChange={handleContainerValue(c.uiId)}
                                                fullWidth
                                            />

                                            <FormControl fullWidth>
                                                <InputLabel>Тип контейнера</InputLabel>
                                                <Select
                                                    name="typeContainerId"
                                                    value={c.typeContainerId}
                                                    onChange={handleContainerValue(c.uiId)}
                                                    label="Тип контейнера"
                                                    MenuProps={{
                                                        disablePortal: true,
                                                        PaperProps: { sx: { zIndex: 20000 } },
                                                    }}
                                                >
                                                    {typeContainers.map((type) => (
                                                        <MenuItem key={type.id} value={type.id}>
                                                            {type.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>

                                            <TextField
                                                name="volume"
                                                label="Объем"
                                                value={
                                                    c.typeContainerId
                                                        ? c.volume === ""
                                                            ? ""
                                                            : String(c.volume)
                                                        : ""
                                                }
                                                placeholder={c.typeContainerId ? undefined : "Выберите тип"}
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                                inputProps={{ min: 0, step: "any" }}
                                            />

                                            <IconButton
                                                aria-label="delete"
                                                onClick={() => dispatch({ type: "REMOVE_CONTAINER", uiId: c.uiId })}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    )}
                    {createdId !== "" && (
                        <>
                            <div className={styles.modalField}>
                                <div className={styles.modalLabel}>Выберете график</div>
                                <div className={styles.modalCoords}>
                                    <Select
                                        name={"scheduleId"}
                                        value={state?.scheduleId}
                                        onChange={handleValue}
                                        renderValue={(selected) =>
                                            schedules?.find((schedule) => schedule.id === selected)?.name ?? ""
                                        }
                                        MenuProps={{
                                            disablePortal: true,
                                            PaperProps: { sx: { zIndex: 20000 } },
                                        }}
                                    >
                                        {schedules?.map((schedule) => (
                                            <MenuItem key={schedule?.id} value={schedule?.id}>
                                                <ListItemText primary={schedule?.name} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </div>
                            </div>
                            <div className={styles.modalLabel}>Или создайте новый график</div>
                            <div className={styles.modalField}>
                                <div className={styles.modalLabel}>Введите название графика</div>
                                <div className={styles.modalCoords}>
                                    <TextField name={"scheduleName"} type={"text"} onChange={handleValue}/>
                                </div>
                                <div className={styles.modalCoords} style={{ width: "100%" }}>
                                    <ScheduleBuilder
                                        onChange={(res) => dispatch({ type: "SET_SCHEDULE", value: res })}

                                    />
                                </div>
                            </div>
                        </>
                    )}
                </div>

                <div className={styles.modalFooter}>
                    <button className={styles.modalButton} onClick={onClose}>
                        Отмена
                    </button>

                    <button
                        className={`${styles.modalButton} ${styles.modalButtonPrimary}`}
                        onClick={createdId === "" ? handleSaveCp : handleSaveSchedule}
                    >
                        {createdId === "" ? "Сохранить" : "Сохранить график"}
                    </button>


                </div>
            </div>
            <SnackbarComponent/>
        </div>
    );
}

